import 'ol/ol.css';
import Map from 'ol/Map.js';
import OSM from 'ol/source/OSM';
import XYZ from 'ol/source/XYZ';
import CartoDB from 'ol/source/CartoDB';
import Static from 'ol/source/ImageStatic';
import Projection from 'ol/proj/Projection';
import Stamen from 'ol/source/Stamen.js';
import TileWMS from 'ol/source/TileWMS.js';
import ImageWMS from 'ol/source/ImageWMS.js';
import ImageLayer from 'ol/source/Image.js';
import TileLayer from 'ol/layer/Tile.js';
import {Group as LayerGroup, Image as ImageLayer, Tile as TileLayer, getSource} from 'ol/layer';
import Overlay from 'ol/Overlay';
import View from 'ol/View.js';
import {getCenter} from 'ol/extent.js';
import proj4 from 'proj4';
import {get as getProjection, toLonLat, fromLonLat, transformExtent} from 'ol/proj';
import {transform} from 'ol/proj';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';
import { DoubleClickZoom } from 'ol/interaction/DoubleClickZoom';
import {FullScreen, defaults as defaultControls} from 'ol/control';

var CoverString="";
var LayerString="";
var StyleString="";

LayerString = localStorage.getItem("LayerStringRadar");
StyleString = localStorage.getItem("StyleStringRadar");

if ( (LayerString != "RADAR_1KM_RSNO" ) && (LayerString != "RADAR_1KM_RRAI" ) ) {
    LayerString = "RADAR_1KM_RRAI";
    CoverString = "RADAR_COVERAGE_RRAI";
}

const toggleTypeElement = document.getElementById("toggleType");
if ( LayerString == "RADAR_1KM_RSNO" ) {

         CoverString="RADAR_COVERAGE_RSNO";
         toggleTypeElement.innerHTML=" Z->S: NEIGE ";

   if ( (StyleString != "RADARURPPRECIPS14" ) && (StyleString != "RADARURPPRECIPS14-LINEAR" ) ) {
       StyleString = "RADARURPPRECIPS14";
   }
} else {
         CoverString="RADAR_COVERAGE_RRAI";
         toggleTypeElement.innerHTML=" Z->R: PLUIE ";

   if ( (StyleString != "RADARURPPRECIPR14" ) && (StyleString != "RADARURPPRECIPR14-LINEAR" ) ) {
       StyleString = "RADARURPPRECIPR14";
   }
}

const toggleStyleElement = document.getElementById("toggleStyle");
if ( StyleString == "RADARURPPRECIPS14" ) {
                toggleStyleElement.innerHTML=" Style Discret";
} else if ( StyleString == "RADARURPPRECIPS14-LINEAR" ) {
                toggleStyleElement.innerHTML="Style Linéaire";
} else if ( StyleString == "RADARURPPRECIPR14" ) {
                toggleStyleElement.innerHTML=" Style Discret";
} else if ( StyleString == "RADARURPPRECIPR14-LINEAR" ) {
                toggleStyleElement.innerHTML="Style Linéaire";
}

localStorage.setItem("LayerStringRadar", LayerString);
localStorage.setItem("StyleStringRadar", StyleString);


///   https://mesonet.agron.iastate.edu/archive/data/2023/03/24/GIS/sat/
///   conus_goes_vis4km_2030.tif
///   conus_goes_ir4km_2030.tif

function toggleType() {

    const toggleTypeElement = document.getElementById("toggleType");

    if ( LayerString == "RADAR_1KM_RSNO" ) {
         LayerString =  "RADAR_1KM_RRAI";
         CoverString="RADAR_COVERAGE_RRAI";
         toggleTypeElement.innerHTML=" Z->R: PLUIE ";

         if ( StyleString == "RADARURPPRECIPS14" ) {
              StyleString =  "RADARURPPRECIPR14";
         } else {
              StyleString = "RADARURPPRECIPR14-LINEAR";
         }
     } else {
         LayerString="RADAR_1KM_RSNO";
         CoverString="RADAR_COVERAGE_RSNO";
         toggleTypeElement.innerHTML=" Z->S: NEIGE ";

         if ( StyleString == "RADARURPPRECIPR14" ) {
              StyleString =  "RADARURPPRECIPS14";
         } else {
              StyleString = "RADARURPPRECIPS14-LINEAR";
         }
     }
     localStorage.setItem("LayerStringRadar", LayerString);
     localStorage.setItem("StyleStringRadar", StyleString);

     console.log(" ---->   resetting Radar Layer: " + LayerString + " Style: " + StyleString);
     NeadLegendUpdate = true;
     check_listTimes_Readiness = setInterval(function() {setTimes()}, 1000);
}

function toggleStyle() {

    const toggleStyleElement = document.getElementById("toggleStyle");

    if ( StyleString == "RADARURPPRECIPS14" ) {
         StyleString =  "RADARURPPRECIPS14-LINEAR";
         toggleStyleElement.innerHTML="Style Linéaire";

    } else if ( StyleString == "RADARURPPRECIPS14-LINEAR" ) {
                StyleString =  "RADARURPPRECIPS14";
                toggleStyleElement.innerHTML=" Style Discret";

    } else if ( StyleString == "RADARURPPRECIPR14" ) {
                StyleString =  "RADARURPPRECIPR14-LINEAR";
                toggleStyleElement.innerHTML="Style Linéaire";

    } else if ( StyleString == "RADARURPPRECIPR14-LINEAR" ) {
                StyleString =  "RADARURPPRECIPR14";
                toggleStyleElement.innerHTML="Style Discret";
    }
        localStorage.setItem("StyleStringRadar", StyleString);

        console.log(" ---->   resetting Radar Layer: " + LayerString + " Style: " + StyleString);
        NeadLegendUpdate = true;
        check_listTimes_Readiness = setInterval(function() {setTimes()}, 1000);
}
const parser = new DOMParser();

//https://geo.weather.gc.ca/geomet/?lang=en&service=WMS&request=GetCapabilities&version=1.3.0&LAYERS=RAQDPS-FW.SFC_PM2.5
// http pour legende plus loin
// introduire les styles   et http poutr style plus loin
//  pas de temps de 1 heure...
//  Voir comment obtenir le temps de depart le plus recent avec cela et ensuite calculer +72h hard.
//  Voir si cela se generalise avec les vagues et les temperatures de l<eau marine
//  Voir si cela est adaptable avec la foudre et les goes aux USA

async function getRadarStartEndTime() {
  let response = await fetch('https://geo.weather.gc.ca/geomet/?lang=en&service=WMS&request=GetCapabilities&version=1.3.0&LAYERS=' + LayerString + '&STYLE=' + StyleString )
  let data = await response.text().then(
    data => {
      let xml = parser.parseFromString(data, 'text/xml')
      let [start, end] = xml.getElementsByTagName('Dimension')[0].innerHTML.split('/')
      let default_ = xml.getElementsByTagName('Dimension')[0].getAttribute('default')
      return [start, end, default_]
    }
  )
  return [new Date(data[0]), new Date(data[1]), new Date(data[2])]
}

let startTime = null;
let endTime = null;
let defaultTime = null;

getRadarStartEndTime().then(data => {                                                                                                            
    startTime = data[0]
    endTime = data[1]
    defaultTime = data[2]
});

const listTimes = [];
const listLoadedA = [];
const listLoadedD = [];

const projView = 'EPSG:3857';

var WrapperFull = "total-wrapper";

const map = new Map({
  controls: defaultControls().extend([new FullScreen({ source: WrapperFull, } )]),
  interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
  moveTolerance: 10,
  target: 'map',
  view: new View({
    center: fromLonLat([-74, 45], projView),
    zoom: 7,
    projection: projView,
    constrainResolution: false,
  }),
});

//   Basemaps layers
const StamenLite = new TileLayer({
      source: new Stamen({
        layer: 'toner-lite',
      }),
      visible: false,
      title: 'StamenLite',
    });

const CartoCDNLight = new TileLayer({
      source: new XYZ({
        url: 'https://{1-4}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png',
        projection: projView || 'EPSG:4326' || 'EPSG:3857',
    attributions: 'Basemap &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a> <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
      }),
      visible: true,
      title: 'CartoCDNLight',
    });

const CartoCDNDark  = new TileLayer({
      source: new XYZ({
        url: 'https://{1-4}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}{r}.png',
        projection: projView || 'EPSG:4326' || 'EPSG:3857',
    attributions: 'Basemap &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a> <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
      }),
      visible: false,
      title: 'CartoCDNDark',
    });
const OSMStandard = new TileLayer({
      source: new OSM(),
        projection: projView || 'EPSG:4326' || 'EPSG:3857',
        visible: false,
        title: 'OSMStandard',
     attributions: ' Basemap &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
    });

const Ahocevar = new TileLayer({
   source: new TileWMS({
      url: 'https://ahocevar.com/geoserver/wms',
        projection: projView || 'EPSG:4326' || 'EPSG:3857',
      params: {
        'LAYERS': 'ne:NE1_HR_LC_SR_W_DR',
        'TILED': true,
     attributions: 'Basemap &copy; <a href="https://ahocevar.com"> Ahocevar</a> &copy; <a href="https://open.canada.ca/data/fr/dataset/8ba2aa2a-7bb9-4448-b4d7-f164409fe056"> CanVec </a>',
      },
    }),
      visible: false,
      title: 'Ahocevar',
  });
const CanvecHydro = new TileLayer({
      source: new TileWMS({
        url: 'https://maps.geogratis.gc.ca/wms/canvec_en',
        params: {'LAYERS':'hydro', 'TILED': true},
        projection: 'EPSG:4326' || 'EPSG:3857',
        minZoom: 6,
        serverType: 'geoserver',
        transition: 0,
      }),
      visible: false,
      title: 'CanvecHydro',
   });

const CanvecElevation = new TileLayer({
      source: new TileWMS({
        url: 'https://maps.geogratis.gc.ca/wms/canvec_en',
        params: {'LAYERS':'elevation', 'TILED': true},
        projection: projView || 'EPSG:4326' || 'EPSG:3857',
        minZoom: 6,
        serverType: 'geoserver',
        transition: 0,
      }),
      visible: false,
      title: 'CanvecElevation',
   });

const CanvecAdmin = new TileLayer({
      source: new TileWMS({
        url: 'https://maps.geogratis.gc.ca/wms/canvec_en',
        params: {'LAYERS':'shoreline_small, shoreline_mid, shoreline_large, shoreline_250k', 'TILED': true},
        projection: 'EPSG:4326' || 'EPSG:3857',
        minZoom: 6,
        serverType: 'geoserver',
        transition: 0,
    zDirection: 1,
      }),
      visible: false,
      title: 'CanvecAdmin',
   });
const CanvecToponymy = new TileLayer({
      source: new TileWMS({
        url: 'https://maps.geogratis.gc.ca/wms/canvec_en',
        params: {'LAYERS':'toponymy', 'TILED': true},
        projection: 'EPSG:4326' || 'EPSG:3857',
        minZoom: 6,
        serverType: 'geoserver',
        transition: 0,
    zDirection: 1,
      }),
      visible: false,
      title: 'CanvecToponymy',
   });

const CanvecTransport = new TileLayer({
      source: new TileWMS({
        url: 'https://maps.geogratis.gc.ca/wms/canvec_en',
        params: {'LAYERS':'transport', 'TILED': true},
        projection: 'EPSG:4326' || 'EPSG:3857',
        minZoom: 6,
        serverType: 'geoserver',
        transition: 0,
    zDirection: 1,
      }),
      visible: true,
      title: 'CanvecTransport',
   });

//
//  stand alone Top map layers :  geographical references to render on top of the weather information
//  in order to provide geographical reference even when the weather information is colored and opaque
//
//  Those are selctable on the layer switcher
//
const StandFordContour =  new TileLayer({
      source: new TileWMS({
        url: 'https://geowebservices.stanford.edu/geoserver/wms',
        params: {'LAYERS': 'druid:hz772ng0160', 'TILED': true},
        //projection: 'EPSG:3857',
        projection: projView || 'EPSG:4326' || 'EPSG:3857',
        maxZoom: 10,
        serverType: 'geoserver',
        //  so do not fade tiles:
        transition: 0,
        zIndex: 98,
    attributions: 'Blue geographic <a href="https://geowebservices.stanford.edu/geoserver/web/"> Stanford U.</a>',
      }),
      visible: true,
      title: 'StandFordContour',
    });

const StamenTonerLines = new TileLayer({
      source: new Stamen({
        layer: 'toner-lines',
      }),
      zIndex: 99,
      visible: false,
      title: 'StamenTonerLines',
    });
//
//  Top map layers Labels:  geographical references Label to render on top of the weather information
//  in order to provide geographical reference even when the weather information is colored and opaque
//
//   These Labels are paired with Basemaps:  they are not offered in the layer swithcher
//   They are set to visible when their associated basemap is selcted
//   For this to work,   it is important that their titles match with the basemap with the addition of "Labels"

const StamenLiteLabels = new TileLayer({
      source: new Stamen({
      layer: 'toner-labels',
      }),
      zIndex: 99,
      visible: false,
     title: 'StamenLiteLabels',
    });

const CartoCDNLightLabels = new TileLayer({
      source: new XYZ({
        url: 'https://{1-4}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png',
        projection: 'EPSG:3857',
    zDirection: 1,
     }),
     zIndex: 100,
     visible: true,
     title: 'CartoCDNLightLabels',
  });

const CartoCDNDarkLabels = new TileLayer({
      source: new XYZ({
        url: 'https://{1-4}.basemaps.cartocdn.com/dark_only_labels/{z}/{x}/{y}{r}.png',
        projection: 'EPSG:3857',
    zDirection: 1,
     }),
     zIndex: 100,
     visible: false,
     title: 'CartoCDNDarkLabels',
  });
const OSMStandardLabels = new TileLayer({
      source: new XYZ({
        url: 'https://{1-4}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png',
        projection: 'EPSG:3857',
    zDirection: 1,
     }),
     zIndex: 100,
     visible: false,
     title: 'OSMStandardLabels',
  });
const AhocevarLabels = new TileLayer({
      source: new XYZ({
        url: 'https://{1-4}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png',
        projection: 'EPSG:3857',
    zDirection: 1,
     }),
     zIndex: 100,
     visible: false,
     title: 'AhocevarLabels',
  });
// Basemaps layer group

const BaseLayerGroup = new LayerGroup({
    layers:[
       StamenLite, CartoCDNLight, CartoCDNDark, OSMStandard, Ahocevar 
    ]
});

// Basemaps overlay layer group 

const BaseOverlayLayerGroup = new LayerGroup({
    layers:[
       CanvecHydro, CanvecElevation
    ]
});
//
//  stand alone Top maps layers group
//

const TopLayerGroup = new LayerGroup({
    layers:[
      StandFordContour, StamenTonerLines, CanvecAdmin, CanvecToponymy, CanvecTransport
    ]
});
//
//    Top Layer Label group
//
const TopLayerLabelGroup = new LayerGroup({
    layers:[
      StamenLiteLabels, CartoCDNLightLabels, CartoCDNDarkLabels, OSMStandardLabels, AhocevarLabels
    ]
});
 
map.addLayer(BaseLayerGroup);
map.addLayer(BaseOverlayLayerGroup);

var looping_ready = false;
var loop_active = false;
var loop_suspended = false;
const radarDLayers = [];
const radarALayers = [];

var NbdeFrames = 3;
var ii =0;

for ( ii = 0 ; ii <= NbdeFrames-1 ; ii++ ) {
   radarDLayers[ii] = new ImageLayer();
   radarALayers[ii] = new ImageLayer();
       map.addLayer(radarDLayers[ii]);
       map.addLayer(radarALayers[ii]);
}

map.addLayer(TopLayerGroup);
map.addLayer(TopLayerLabelGroup);
//   Layer switcher Logic for basemaps  and their associated Top Layers Labels
//

const BaseLayerElements = document.getElementsByName("baseLayerRadioButton");
for ( let BaseLayerElement of BaseLayerElements) {

    BaseLayerElement.addEventListener('change', function(){
                let BaseLayerElementValue = this.value;
                BaseLayerGroup.getLayers().forEach(function(element, index, array){
                        let BaseLayerTitle = element.get('title');
            console.log(" Title: " + BaseLayerTitle + " Value: " + BaseLayerElementValue);
                        element.setVisible(BaseLayerTitle === BaseLayerElementValue);
                })
        //   Here is why the values and titles are matched 
                let TopLayerElementLabel = BaseLayerElementValue + "Labels";
                TopLayerLabelGroup.getLayers().forEach(function(element, index, array){
                        let TopLayerLabelTitle = element.get('title');
            console.log(" Title: " + TopLayerLabelTitle + " Label: " + TopLayerElementLabel);
                        element.setVisible(TopLayerLabelTitle === TopLayerElementLabel);
                })
        })
}

//   Layer er Logic for basemaps overlays   and Top Layers overlays having checkbox in the HTML
//

//const LayerElements = document.querySelectorAll('.sidenav > input[type=checkbox]');
const LayerElements = document.getElementsByName("topLayerCheckBox");
for ( let LayerElement of LayerElements) {
    LayerElement.addEventListener('change', function(){
        let LayerElementValue = this.value;
        BaseOverlayLayerGroup.getLayers().forEach(function(element, index, array){
            let BaseOverlayLayerTitle = element.get('title');
            if ( BaseOverlayLayerTitle === LayerElementValue) {
                element.setVisible(  LayerElement.checked ) ;
            }
            })
        TopLayerGroup.getLayers().forEach(function(element, index, array){
                        let TopLayerTitle = element.get('title');
                        if ( TopLayerTitle === LayerElementValue) {
                                element.setVisible(  LayerElement.checked ) ;
                        }
        })
    })
}

///---------------------Set view ------------------------------------

var viewExtent_ = map.getView().calculateExtent(map.getSize());
var viewProj_ = map.getView().getProjection();
if ( viewProj_ != 'EPSG:4326' ) { viewExtent_ = transformExtent(viewExtent_, viewProj_, 'EPSG:4326'); }

const newView = new View({
        projection: 'EPSG:4326',
        zoom: 25,
        zoomFactor: 1.26,  // zoomFactor is 2 by default, i.e.  factor 2 at each steps
        //extent: viewExtent_,
        center: [-74, 45],
        constrainResolution: false,
        showFullExtent: true,
        multiWorld: false,
     });

map.setView(newView);

//  --------------------------------------------------------------------------
//   Legends settings et preparation 
//   ------------------------------------------------------------------------

var NeadLegendUpdate = true;
var checkIfLegendUpdated = null;

var Lgnd1Large = true;

Lgnd1Large = localStorage.getItem("Lgnd1Large");

if ( (Lgnd1Large != true ) && (Lgnd1Large != false ) ) {
    Lgnd1Large = true;
}

localStorage.setItem("Lgnd1Large", Lgnd1Large);

const Lgnd1Select = document.getElementById('lgnd1Button');
const Lgnd1Img = document.getElementById("lgnd1Image");

Lgnd1Img.onload = function () { NeadLegendUpdate = false; showLgnd(); showLgnd(); };

const updateLegend = function() {

//https://geo.weather.gc.ca/geomet?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=RAQDPS-FW.SFC_PM2.5&format=image/png&STYLE=RAQDPS-SFC-PM_KGM3
//https://geo.weather.gc.ca/geomet?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=RAQDPS-FW.SFC_PM2.5&format=image/png&STYLE=RAQDPS-SFC-PM_UGM3

  Lgnd1Img.src = 'https://geo.weather.gc.ca/geomet/?lang=en&service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=' + LayerString + '&STYLE=' + StyleString + '&FORMAT=image/png&SLD_VERSION=1.1.0';

};

function seeIfLegendUpadated() {

    if ( NeadLegendUpdate ) {  return };

    if ( checkIfLegendUpdated != null ) { clearInterval(checkIfLegendUpdated); }
    checkIfLegendUpdated = null;
}

// ________________________________________________________________________________
function showLgnd() {

  var lgndId = "lgnd1Image";
  
  const x = document.getElementById( lgndId );
  const frame = document.getElementById( "panel" );

  const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  
  var  gauche = true;
  var  haut= true;
  var  distH, distV, milieu ;

////  findout in which quadrant the legend is prior to modification
// for positionning at the end of the resizing process
////  want to ensure the collapsing-expanding is toward-from de edges - corners
    
   distH = parseInt( frame.style.left.replace('px','') );
   milieu = (viewwidth - x.width)/2;

  if ( distH > milieu ) {  gauche = false; }

  distV = parseInt( frame.style.top.replace('px','') ); 
  milieu = (viewheight - x.height) /2;

  if ( distV > milieu ) {  haut = false;  }

//    store the previous sizes for later use before resizing    
  var deltaX = x.width;
  var deltaY = x.height;

  var fact = Math.min( Math.max(  (viewwidth/1000.), 0.6 ), 1 );
  
  if ( Lgnd1Large )  {

      Lgnd1Large =false; 
localStorage.setItem("Lgnd1Large", Lgnd1Large);
      x.width = x.naturalWidth/10;
      x.height= x.naturalHeight/10;

  } else {

      Lgnd1Large =true;
localStorage.setItem("Lgnd1Large", Lgnd1Large);
      x.width = parseInt( x.naturalWidth * fact );
      x.height= parseInt( x.naturalHeight * fact );
  } 

//  the resize is made but we need to manage the position of the legend panel
//  the default is to collaspe towards the top-left and expand towards the lower right
//  We want to have collapsing toward the nearest corner and expanding inversely
    
  deltaY = x.height - deltaY;
  deltaX = x.width - deltaX;

  if ( !gauche ) {
      distH =  distH  - deltaX;
      frame.style.left = distH  + "px";
//    console.log("distH et deltax" + distH + " " + deltaX) ;
  }
  if ( !haut ) {
    distV  =  distV - deltaY;   
    frame.style.top = distV + "px"; 
//    console.log("distV et deltaY" + distV + " " + deltaY) ;
  }
}
// ----------------------------------------------------------------------------
// Handle change event.
//
Lgnd1Select.onchange = function () { showLgnd() };

 $("#lgnd1Button").click(function(){
  console.log('click lgnd1 button');
  showLgnd();
});

// Make the legend DIV container a draggable:
dragElement(document.getElementById("lgndMButton"),
            document.getElementById("panel"), "legende");

// ________________________________________________________________________________
//
function dragElement(elmnt_anchor, elmnt2Move, initialPosition) {
  var posX1 = 0, posY1 = 0, posX2 = 0, posY2 = 0;
  var message = " ";

//    elmnt.onmousedown = dragMouseDown;
    elmnt_anchor.addEventListener("mousedown", dragMouseDown);
    elmnt_anchor.addEventListener("touchstart", dragMouseDown);
//    elmnt_anchor.ontouchstart = dragMouseDown;
    //
    //

  function dragMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
    // get the mouse cursor position at startup:
      // event.changedTouches[0].pageX  event.changedTouches[0].pageY
      //
    posX1 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
    posY1 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;

//    message = " grab mouse: " + pos3 + " " + pos4;
//    openAfficheInfo(message,10);
      document.addEventListener("mouseup", closeDragElement);
      elmnt_anchor.addEventListener("touchend", closeDragElement);
    // call a function whenever the cursor moves:
     document.addEventListener("mousemove", elementDrag);   
       elmnt_anchor.addEventListener("touchmove", elementDrag);   
  }

  function elementDrag(e) {
    
    e = e || window.event;
    e.preventDefault();
   // calculate the new cursor position:
    posX2 = e.pageX || e.clientX || event.touches[0].pageX || event.originalEvent.Touches[0].pageX || event.changedTouches[0].pageX;
    posY2 = e.pageY || e.clientY || event.touches[0].pageY || event.originalEvent.Touches[0].pageY || event.changedTouches[0].pageY;

    var deltaX = posX2 - posX1;
    var deltaY = posY2 - posY1;
    const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    const limitEnBas = viewheight - elmnt2Move.offsetHeight;
    const limitADroite = viewwidth -elmnt2Move.offsetWidth-30;

    // set the element's new position:
    elmnt2Move.style.top = Math.max( Math.min( (elmnt2Move.offsetTop + deltaY), limitEnBas ) , 100) + "px";
    elmnt2Move.style.left= Math.max( Math.min( (elmnt2Move.offsetLeft+ deltaX), limitADroite ) , 10 ) + "px";

//  Storing current positions into latest position for next iteration
    posX1 = posX2;
    posY1 = posY2;
  }
  function closeDragElement() {
    // stop moving when mouse button is released:
//    document.onmouseup = null;
//    document.ontouchend = null;
//    document.onmousemove = null;
//    document.ontouchmove = null;
    document.removeEventListener("mouseup", closeDragElement);
    elmnt_anchor.removeEventListener("touchend", closeDragElement);
    document.removeEventListener("mousemove", elementDrag);
    elmnt_anchor.removeEventListener("touchmove", elementDrag);
  }

    // set the element's  Initial position as requested by the 3 rd parameter 
    //
  const viewheight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  const viewwidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  const limitEnBas = Math.max( 0, viewheight - elmnt2Move.offsetHeight);
  const limitADroite = Math.max( 0, viewwidth -elmnt2Move.offsetWidth);

  if ( initialPosition == "legende" ) {                                                                                                                                              
    var basDeLegende= limitEnBas - 350;
    elmnt2Move.style.top = Math.max( basDeLegende, 150) + "px";
    elmnt2Move.style.left= Math.min( limitADroite, 30 ) + "px";

  } else if ( initialPosition == "btnGroup" )  {

    var basDeBtnGroup= limitEnBas - 100;
    elmnt2Move.style.top = Math.max( basDeBtnGroup, 100) + "px";
    elmnt2Move.style.left= Math.min( limitADroite, 400)  + "px";

  } else if ( initialPosition == "afficheHor" )  {
    
    elmnt2Move.style.top = Math.min( limitEnBas, 100) + "px";
    elmnt2Move.style.left= Math.min( limitADroite, 50) + "px";

  } else if ( initialPosition == "upperLeft" )  {

    elmnt2Move.style.top = Math.min( limitEnBas, 100) + "px";
    elmnt2Move.style.left= Math.min( limitADroite, 30 ) + "px";
  }
}

///----------------------------------------------------------------------------

dragElement(document.getElementById("moveAfficheHor"),
            document.getElementById("divAfficheHor"), "afficheHor");
///----------------------------------------------------------------------------

function InitializeListTimes(startTime_, endTime_, defaultTime_) {

    let ready = false;
    console.log( "startTime: "  + startTime_  + " End: " + endTime_ + " defaultTime: " + defaultTime_);

    if ( startTime_ === null ) {
       ready = false;

    } else if ( NeadLegendUpdate ) {
       ready = false;

       if ( checkIfLegendUpdated == null ) { 
          updateLegend();
          checkIfLegendUpdated = setInterval(function() {seeIfLegendUpadated()}, 500);
        }

    } else {
       ready = true;

       var ii = 0;
       let current_time = new Date(startTime_); 
         //current_time = new Date(current_time.setUTCMinutes(current_time.getUTCMinutes() + 36));
         listTimes[0] = current_time; 
         listLoadedA[0] = "non";
         listLoadedD[0] = "non";
         console.log(" Compteur: " + ii + " current Time: " + current_time);
         current_time = new Date(current_time.setUTCMinutes(current_time.getUTCMinutes() + Interval));

       while (current_time < endTime_) {
         ii++;
         listTimes[ii] = current_time; 
         listLoadedA[ii] = "non";
         listLoadedD[ii] = "non";
         console.log(" Compteur: " + ii + " current Time: " + current_time);
         console.log(" Compteur: " + ii + "Loaded A: " + listLoadedA[ii] + "Loaded B: " + listLoadedD[ii]);
         current_time = new Date(current_time.setUTCMinutes(current_time.getUTCMinutes() + Interval));
       }
       current_time = new Date(listTimes[ii]);

       while ( listTimes.length % NbdeFrames != 0 ) {
             ii++;
             listTimes[ii] = current_time;
             listLoadedA[ii] = "non";             
             listLoadedD[ii] = "non";
       }
    }
    return  ready
}

var check_listTimes_Readiness = setInterval(function() {setTimes()}, 1000);

function setTimes() {
    if ( loop_active ) {loop_suspended = true}; 
    stop();
    looping_ready = false;
    startTime = startTime;
    endTime = endTime;
    defaultTime = defaultTime;
    let listTimes_ready = InitializeListTimes(startTime, endTime, defaultTime);
    console.log(" setTimes: " + startTime, endTime, defaultTime);
    if ( listTimes_ready ) {
                 if ( check_listTimes_Readiness != null ) { clearInterval(check_listTimes_Readiness); }
                 check_listTimes_Readiness = null;
                 finL=listTimes.length-1; 
                 if ( Istep == 0 ) { Istep=listTimes.length-1; }
                 Istep_max=listTimes.length-1;
                 resetSource(Istep);
                 resetSource(0);
                 let index = Istep % NbdeFrames;
                 radarALayers[index].setOpacity(1);
                 radarDLayers[index].setOpacity(1);
                 const myTimeout = setTimeout(function() { resume_loop() }, 500);
                 let loc_time = new Date(listTimes[Istep]);
                 console.log("TimeStep Istep affiche: " + Istep);
                 updateInfo(loc_time)
    }
}

var NewstartTime = null;
var NewendTime = null;
var NewdefaultTime null;
var checkIfTimeResetDue = null;

function seeIfTimeResetDue() {

    if ( NewstartTime == null ) {  return };

    startTime = startTime;
    endTime = endTime;
    defaultTime = defaultTime;

    if ( checkIfTimeResetDue != null ) { clearInterval(checkIfTimeResetDue); }
    checkIfTimeResetDue = null;

    if ( NewstartTime != startTime ) {

        console.log(" ---->   resetting times <-----");

        startTime = NewstartTime;
        endTime = NewendTime;
        defaultTime = NewdefaultTime;
        NewstartTime = null;
        setTimes();

    } else {
        console.log(" ----> No time resetting needed <-----");
    }
}

function resetTimes() {


  getRadarStartEndTime().then(data => {                                                                                                            
    NewstartTime = data[0]
    NewendTime = data[1]
    NewdefaultTime = data[2]
   });
   checkIfTimeResetDue = setInterval(function() {seeIfTimeResetDue()}, 1000);
}

var checkResetTimes = setInterval(function() {resetTimes()}, 360500);


function resetSource( istep) {

    var returnLoading = false;
 
   var index = istep % NbdeFrames;
   var indice = 0;
    var message="resetSource  imageload Requested, for istep ; " + istep + " index: " + index;
             console.log(message);

     let loc_time = new Date(listTimes[istep]);
         loc_time = loc_time.toISOString().split('.')[0]+"Z";
 
//  'CRS': 'EPSG:4326',

      if ( listLoadedD[istep] == "non" ) {
         const sourceD = new ImageWMS({
                format: 'image/png',
                url: 'https://geo.weather.gc.ca/geomet/',
//                params: {'LAYERS': LayerString, 'EPSG:4326','STYLE': StyleString,'TILED': true, 'TIME': loc_time },
                params: {'LAYERS': LayerString, 'STYLE': StyleString,'TILED': true, 'TIME': loc_time },
                crossOrigin: 'Anonymous',
               attributions: 'Sources météo: <a href="https://eccc-msc.github.io/open-data/">ECCC</a>'
            });

            sourceD.on('imageloadend', function () {
                //var message=" tileload end fired for layer D step: " + istep ;
                //console.log(message);
                listLoadedD[istep] = "yes";
                });
            sourceD.on('imageloaderror', function () {
                //var message=" tileload error fired for layer D : " + istep;
                //console.log(message);
                listLoadedD[istep] = "error";
                });

                for ( indice = index; indice <= Istep_max; indice=indice+NbdeFrames ) {
                        listLoadedD[indice] = "non"; 
                }
            
            radarDLayers[index].setSource(sourceD);
            listLoadedD[istep] = "loading";
            returnLoading = true;
            console.log( " loading D: " + istep);
            radarDLayers[index].setOpacity(0);

      } else if ( listLoadedD[istep] == "loading" ) {
            console.log( "wait while D loading: " + istep);
      } else if ( listLoadedD[istep] == "yes" ) {
            console.log( " D is already loaded: " + istep);
      } else if ( listLoadedD[istep] == "error" ) {
            console.log( " D is in error: " + istep);
            listLoadedD[istep] = "non";
      } else {
            console.log( " Issue D istep: " + istep + " listLoaded: " + listLoadedD[istep] )
      }
      if ( listLoadedA[istep] == "non" ) {
         const sourceA = new ImageWMS({
                format: 'image/png',
                url: 'https://geo.weather.gc.ca/geomet/',
                //params: {'LAYERS': CoverString, 'CRS': 'EPSG:4326','STYLE': 'Radar-Coverage_BLACK-OUTLINE', 'TILED': true, 'TIME': loc_time },
                params: {'LAYERS': CoverString, 'STYLE': 'Radar-Coverage_BLACK-OUTLINE', 'TILED': true, 'TIME': loc_time },
                transition: 0,
                crossOrigin: 'Anonymous',
            });
            sourceA.on('imageloadend', function () {
                //var message=" tileload end fired for layer D step: " + istep ;
                //console.log(message);
                listLoadedA[istep] = "yes";
                });
            sourceA.on('imageloaderror', function () {
                //var message=" tileload error fired for layer D : " + istep;
                //console.log(message);
                listLoadedA[istep] = "error";
                });

                for ( indice = index; indice <= Istep_max; indice=indice+NbdeFrames ) {
                        listLoadedA[indice] = "non"; 
                }

            radarALayers[index].setSource(sourceA);
            listLoadedA[istep] = "loading";
            returnLoading = true;
            console.log( " loading A: ", istep);
            radarALayers[index].setOpacity(0);

      } else if ( listLoadedA[istep] == "loading" ) {
            console.log( " wait while A loading: ", istep);
      } else if ( listLoadedA[istep] == "yes" ) {
            console.log( " A is already loaded: ", istep);
      } else if ( listLoadedA[istep] == "error" ) {
            console.log( " A is in error: " + istep);
            listLoadedA[istep] = "non";
      } else {
            console.log( "Issue with A istep: " + istep + " listLoaded: " + listLoadedA[istep] )
      }
}

// ________________________________________________________________________________
//
function getAfficheValidDateTime(houroid_, nb_minutes)  {
        
        let nb_ms = nb_minutes * 6e4;

        let string= houroid_.substring(0,4) + "-" + houroid_.substr(4,2) + "-" + houroid_.substr(6,2) + " " + houroid_.substr(8,2);
        if ( houroid_.length == 10 ) {
              string= string + ":00:00";
        } else {
              string= string + ":" + houroid_.substr(10,2) + ":00";
        }
        let d1 = new Date(string);     
        let days = ["Dim.", "Lun.","Mar.","Mer.","Jeu.","Ven.","Sam."];

        d1.setMinutes(d1.getMinutes() + parseInt(nb_minutes));

        let offset_UTC_m =  d1.getTimezoneOffset()  ;

        d1.setMinutes(d1.getMinutes() - offset_UTC_m);

        offset_UTC_m = Math.round( offset_UTC_m/60. );
        let offset_UTC_string = offset_UTC_m.toString();

        let d4 = d1.toLocaleDateString("en-GB");
        let d5 = d1.toLocaleTimeString("en-US",{hour12: false } );

        if ( d5.slice(0, 2) == 24 ) { d5="00" +  d5.slice(2, 5) }
        d4 = d4.slice(0, 15) + " ";
        let d6 = days[d1.getDay()] + " le " + d4 + " à " + d5.slice(0, 5) + "h (UTC-" + offset_UTC_string + "h)" ;
        
    return d6
}

//------------------------------------------------------------------------
function updateInfo(current_time) {

        let d1 = current_time;
        let days = ["Dim.", "Lun.","Mar.","Mer.","Jeu.","Ven.","Sam."];

        let offset_UTC_m =  d1.getTimezoneOffset()  ;

        //d1.setMinutes(d1.getMinutes() - offset_UTC_m);

        offset_UTC_m = Math.round( offset_UTC_m/60. );
        let offset_UTC_string = offset_UTC_m.toString();

        let d4 = d1.toLocaleDateString("en-GB");
        let d5 = d1.toLocaleTimeString("en-US",{hour12: false } );

        if ( d5.slice(0, 2) == 24 ) { d5="00" +  d5.slice(2, 5) }
        d4 = d4.slice(0, 15) + " ";
        let d6 = days[d1.getDay()] + " le " + d4 + " à " + d5.slice(0, 5) + "h (UTC-" + offset_UTC_string + "h)" ;

       document.getElementById("affiche_temps_valide").innerHTML =  d6;
}

//------------------------------------------------------------------------
var Istep = 0;
var Istep_max = 0;
var finL = 30;
var debutL = 0;
var Interval = 6;
var DureeMax = 180;

// ________________________________________________________________________________
//
// -----------------------------------------------------------------------------------
//   Selector  for debutL

const DebutLSelect = document.getElementById('selectDuree');

// Introduce delay in execution to allow proper calculation of debutL when finL is determined
// finL is obtained at the end of the setTimes process,  initialised from getCapabilites etc.

setTimeout(function() {  setMenuDebutLSelect(true, DebutLSelect); }, 2000);

//------------------------------------------------------------------------
function updateDebutLFromMenu( debutLSelect) {

    if ( loop_active  ) { loop_suspended = true; stop(); }

    let duree = debutLSelect.options[debutLSelect.options.selectedIndex].value ;
    localStorage.setItem("WMSDuree", duree);

    debutL = Math.max(0, (finL - Math.floor( duree / Interval )) );

    if ( loop_suspended ) { loop_suspended = false; play(); }
}

// ------------------______________________________________________________________
// Handle change event.
//
DebutLSelect.onchange = function () { updateDebutLFromMenu( DebutLSelect) };

// ________________________________________________________________________________
//
function setMenuDebutLSelect(init, debutLSelect) {

   let debutLMax = Math.max(0, (finL - Math.floor( DureeMax / Interval )) );
   let duree = 0;

   if ( init ) {
      duree = localStorage.getItem("WMSDuree");
                  console.log(" duree is set from localStorage:" + duree);
      debutL = Math.max(0, (finL - Math.floor( duree / Interval )) );
                  console.log(" debutL is calculated  from duree (localStorage):" + debutL);

   } else if ( ( debutL >= 0 ) && ( debutL <= debutLMax ) ) { 

       duree = Math.floor( Math.max(0, (finL - debutL)) * Interval ) ;
       console.log(" duree is set from localStorage:" + duree);

   }  else {
       debutL = debutLMax;
       duree = DureeMax;
   }

   debutLSelect.options.length = 0;

   debutLSelect.options[debutLSelect.options.length]  = new Option( '30 min', 30);
   debutLSelect.options[debutLSelect.options.length]  = new Option( '60 min', 60);
   debutLSelect.options[debutLSelect.options.length]  = new Option( '120 min', 120);
   debutLSelect.options[debutLSelect.options.length]  = new Option( '180 min', 180);
   
   let changee = resetDebutL( duree, debutLSelect );
}

//------------------------------------------------------------------------
function resetDebutL( duree, debutLSelect ) {

   let found = false;

   for ( let ii =0; ii < debutLSelect.options.length; ii++ ) {
             if ( debutLSelect.options[ii].value == duree ) {
                  debutLSelect.options.selectedIndex = ii;
                  console.log(" duree is set back to:" + duree + " ii: " + ii);
                  found = true;
             }
        }
   if ( !found ) {
      console.log(" duree was not found in menu selections:" + duree);
      debutLSelect.options.selectedIndex = 0;
      console.log(" duree is set back to:" + duree + " ii: " + ii);
   }
   updateDebutLFromMenu(debutLSelect);
}

//------------------------------------------------------------------------
function TimeStep(step) {

    if ( looping_ready ) {

       let indexPrev = Istep  % NbdeFrames;
       var istep = Istep + step;

       console.log("TimeStep : " + istep);
       console.log("TimeStep debutL finL: " + debutL + " " + finL);

       if ( istep < debutL ) { istep = finL; console.log("TimeStep istep devient: " + istep); } 
       if ( istep > finL ) {  istep = debutL; console.log("TimeStep istep devient: " + istep);}

       let istepNext = istep + step;
       if ( istepNext < debutL ) { istepNext = finL; console.log("TimeStep istepNext devient: " + istepNext); } 
       if ( istepNext > finL ) {  istepNext = debutL; console.log("TimeStep istepNext devient: " + istepNext);}
      
       if ( listLoadedD[istep] == "yes"  && listLoadedA[istep] == "yes" ) {

            Istep = istep;
            resetSource(istepNext);

            let loc_time = new Date(listTimes[Istep]);
            console.log("TimeStep Istep affiche: " + Istep);
            updateInfo(loc_time)

            let index = Istep  % NbdeFrames;
           
            radarDLayers[indexPrev].setOpacity(0.0);
            radarALayers[indexPrev].setOpacity(0.0);
            radarDLayers[index].setOpacity(1);
            radarALayers[index].setOpacity(1);
        } else {
            resetSource(istep);
        }

    } else {
      console.log(" looping is not ready ");
    }
}

var MaxRepeatStep = 5;
var IstepRepeated =0;

function Step() {
   if ( (Istep == finL) && (IstepRepeated < MaxRepeatStep ) ) {
     IstepRepeated = IstepRepeated + 1;
     console.log("TimeStep is into the repetition: " + Istep);
   } else {
     IstepRepeated = 0;
     TimeStep(1);
   }
}

var FrameRate = 3.0; // frames per second
var InitFrameRate = 3.0; // frames per second
var animationId = null;
var Avance = true;

function resume_loop() {
  looping_ready = true; 
  if ( loop_suspended ) {
       loop_suspended = false;
       play();
  }
}
// ________________________________________________________________________________
//
function DesactiveAndStop() {

  stop();
     document.getElementById('StopAnimate').style.display = "none";
     document.getElementById('StartAnimate').style.display = "initial";
}

function stop() {
  if (animationId !== null) {
    clearInterval(animationId);
    animationId = null;
    loop_active = false;
  }
  if ( looping_ready ) { 
            finL=listTimes.length-1; 
  }
};

$("#StopAnimate").click(function(){ DesactiveAndStop(); });
// ________________________________________________________________________________
//
function ActivateAndStart() {
     play();
     document.getElementById('StartAnimate').style.display = "none";
     document.getElementById('StopAnimate').style.display = "initial";
}

function play() {
  stop();
  loop_active = true;
  Avance = true;
  animationId = setInterval(function() {Step()}, 1000 / FrameRate);
};

$("#StartAnimate").click(function(){ ActivateAndStart(); });
// ________________________________________________________________________________
//
function foreward() {
  DesactiveAndStop();
  Avance = true;
  TimeStep(1);
}
$("#StepForward").click(function(){ foreward(); });
// ________________________________________________________________________________
//
function backward() {
  DesactiveAndStop();
  Avance = false;
  TimeStep(-1);
}
$("#StepBackward").click(function(){ backward(); });

// ________________________________________________________________________________
function StepPre() {

    DesactiveAndStop();
    if ( Avance )  {
        backward();
    } else {
        foreward();
    }
}

$("#StepPre").click(function(){ StepPre(); });

// ________________________________________________________________________________
function GoToLastStep() {
     
     DesactiveAndStop();

     let index = Istep  % NbdeFrames;
           
     radarDLayers[index].setOpacity(0);
     radarALayers[index].setOpacity(0);
    
     resetSource(finL);

    var message="goto last step loading: " + Istep;
        console.log(message);

    Avance = true;
    Istep = finL - 1;
    setTimeout(function() {  TimeStep(1); }, 350);
}
// ________________________________________________________________________________
//
 $("#GoToLastStep").click(function(){ GoToLastStep(); });


// ________________________________________________________________________________
function GoToFirstStep() {
     
     DesactiveAndStop();

     let index = Istep  % NbdeFrames;
           
     radarDLayers[index].setOpacity(0);
     radarALayers[index].setOpacity(0);
    
     resetSource(debutL);

    var message="goto first step loading: " + Istep;
        console.log(message);

    Avance = true;
    Istep = finL;
    setTimeout(function() {  TimeStep(1); }, 350);
}
// ________________________________________________________________________________
//
 $("#GoToFirstStep").click(function(){ GoToFirstStep(); });
// ________________________________________________________________________________
//
function SpeedReset() {

    if ( loop_active  ) { loop_suspended = true; stop(); }
        delay = 1000 / InitFrameRate;
        animationId = setInterval(function() {Step()}, delay);       
    if ( loop_suspended ) {
             loop_suspended = false;
             play();
        }
}
// ________________________________________________________________________________
function Slower() {

    if ( loop_active  ) { loop_suspended = true; stop(); }
        let delay = 1000 / FrameRate;
        delay = delay*1.26;
        if (delay > 20480) delay = 20480;
        FrameRate = 1000 / delay;
        console.log(" Delay: " + delay)
    if ( loop_suspended ) {
             loop_suspended = false;
             play();
        }
}
// ________________________________________________________________________________
//
 $("#Slower").click(function(){ Slower(); });
// ________________________________________________________________________________
function Faster() {

    if ( loop_active  ) { loop_suspended = true; stop(); }
        let delay = 1000 / FrameRate;
        delay = delay/2.;
        if (delay < 40) delay = 40;
        FrameRate = 1000 / delay;
        console.log(" Delay: " + delay)
    if ( loop_suspended ) {
             loop_suspended = false;
             play();
        }
}
// ________________________________________________________________________________
//
 $("#Faster").click(function(){ Faster(); });
// ________________________________________________________________________________

dragElement(document.getElementById("moveBtnGroup"),
            document.getElementById("btn-group"), "btnGroup"   );

        
let exportMapFunction = function(e) {
  map.once('postcompose', function(event) {
    var canvas = event.context.canvas;
    canvas.toBlob(function(blob) {
      saveAs(blob, 'msc-geomet_web-map_export.jpg')
    }, 'image/jpeg',0.9);
  });
  map.renderSync();
};

let typeButton = document.getElementById('toggleType');
typeButton.addEventListener( 'click', toggleType, false);

let styleButton = document.getElementById('toggleStyle');
styleButton.addEventListener( 'click', toggleStyle, false);

// ________________________________________________________________________________
        
/* Set the width of the side navigation to 300px and the left margin of the page content to 300px */
function openSideNav() {
  document.getElementById("mySidenav").style.width = "300px";
  document.getElementById("total-wrapper").style.marginLeft = "300px";
    window.dispatchEvent(new Event('resize'));
}

// -----------------------------------------------------------------------------------
//
 $("#openSideNav").click(function(){ openSideNav(); });

/* Set the width of the side navigation to 0 and the left margin of the page content to 0 */
function closeSideNav() {
  document.getElementById("mySidenav").style.width = "0";
  document.getElementById("total-wrapper").style.marginLeft = "0";
    window.dispatchEvent(new Event('resize'));
}
// -----------------------------------------------------------------------------------
//
 $("#closeSideNav").click(function(){ closeSideNav(); });

// ________________________________________________________________________________

